import { render, staticRenderFns } from "./CandidateCourseHistoryItem.vue?vue&type=template&id=05e16295&scoped=true&lang=pug&"
import script from "./CandidateCourseHistoryItem.vue?vue&type=script&lang=js&"
export * from "./CandidateCourseHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./CandidateCourseHistoryItem.vue?vue&type=style&index=0&id=05e16295&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e16295",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
